import { Controller } from "@hotwired/stimulus"

// Opens the global ad modal from any tile that carries data-src / data-link / etc.
export default class extends Controller {
  open(event) {
    // Do not preventDefault: it can interfere with nested controls / carousel + Turbo.
    const el = event.currentTarget
    const showButton = el.dataset.isButtonVisible === "true" || el.dataset.isButtonVisible === "1"

    document.dispatchEvent(
      new CustomEvent("mo:open-ad-modal", {
        bubbles: true,
        cancelable: true,
        detail: {
          src: el.dataset.src || "",
          link: el.dataset.link || "#",
          alt: el.dataset.alt || "",
          showButton,
        },
      })
    )
  }
}
